import {
  PlannedQty,
  PlannedQtyCreateRequest,
  PlannedQtyUpdateRequest,
} from '../../types/app/plannedQty.types';
import { api } from '../core/api';

export const getPlannedQtyList = (id?: number) =>
  api.get<PlannedQty[]>(`PlannedQty/GetList?parentId=${id}`).then((res) => res.data);

export const getPlannedQty = (id: number) =>
  api.get<PlannedQty>(`PlannedQty/GetItem/?id=${id}`).then((res) => res.data);

export const updatePlannedQty = (data: PlannedQtyUpdateRequest) =>
  api.put(`PlannedQty/UpdateItem`, data).then((res) => res.data);

export const createPlannedQty = (data: PlannedQtyCreateRequest) =>
  api.post(`PlannedQty/CreateItem`, data).then((res) => res.data);

export const deletePlannedQty = (id: number) =>
  api.delete<PlannedQty>(`PlannedQty/DeleteItem/?id=${id}`).then();
